import React from 'react';
import { renderReadingPlan } from './shared/renderers';

/**
 * ReadingPlanBlock — rendu PARTAGÉ avec l'éditeur intranet (shared/renderers).
 * Carte image/texte, badge catégorie, durée, lien YouVersion, signature.
 */
export default function ReadingPlanBlock({ props = {}, theme }) {
  return renderReadingPlan(props, theme);
}
